import { createStore } from 'vuex';

const store = createStore({
    state:{
        pageslist: [],
        medialist: [],
    },
    mutations:{
        INCREMENT(state){
            state.pageslist = []
            state.medialist = []
        }
    },
    actions:{}
});

export default store;